import { Grid3x3, List } from 'lucide-react';
import React from 'react';
import { cn } from '../lib/utils';

/**
 * ViewToggle Component
 * Toggle between table and card view
 *
 * @param {Object} props
 * @param {'table' | 'cards'} props.view - Current view mode
 * @param {Function} props.onViewChange - Handler for view change
 */
export function ViewToggle({ view = 'table', onViewChange }) {
  return (
    <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg p-1">
      <button
        onClick={() => onViewChange('table')}
        className={cn(
          'px-3 py-2 rounded-md transition-colors',
          view === 'table'
            ? 'bg-blue-100 text-blue-600'
            : 'text-gray-600 hover:bg-gray-100'
        )}
      >
        <List className="w-5 h-5" />
      </button>
      <button
        onClick={() => onViewChange('cards')}
        className={cn(
          'px-3 py-2 rounded-md transition-colors',
          view === 'cards'
            ? 'bg-blue-100 text-blue-600'
            : 'text-gray-600 hover:bg-gray-100'
        )}
      >
        <Grid3x3 className="w-5 h-5" />
      </button>
    </div>
  );
}



